import { IGenericError, TotalPassEventOccurrence } from '@libs/entity-lib';
import { createReducer, on } from '@ngrx/store';
import * as fromActions from './totalpass.actions';

export interface State {
  loading: boolean;
  error: IGenericError | null;
  isActive: boolean;
  slot?: TotalPassEventOccurrence;
}

export const initialState: State = {
  error: null,
  loading: false,
  isActive: false,
};

export const reducer = createReducer(
  initialState,
  on(fromActions.fetchTotalPassActivation, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(fromActions.fetchTotalPassActivationSuccessfully, (state, { response }) => ({
    ...state,
    loading: false,
    isActive: response.isActive,
  })),
  on(fromActions.fetchTotalPassActivationFailed, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(fromActions.fetchTotalPassSlotDetails, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(fromActions.fetchTotalPassSlotDetailsSuccessfuly, (state, { slot }) => ({
    ...state,
    loading: false,
    slot,
  })),
  on(fromActions.fetchTotalPassSlotDetailsFailed, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
